import { useMemo } from "react";

import { formatTimestamp } from "~/utils/helpers";

import { useMediaPlayerContext } from "../media/context";
import { MediaProgress } from "../media/MediaProgress";

export function VideoTimeline() {
  const { currentTime, duration, seeking, seekingTime } =
    useMediaPlayerContext();

  const playheadTime = useMemo(
    () => (seeking ? seekingTime : currentTime),
    [currentTime, seeking, seekingTime],
  );

  return (
    <div className="VideoTimeline">
      <div className="VideoTimeline__current-time">
        {formatTimestamp(playheadTime)}
      </div>

      <div className="VideoTimeline__progress">
        <MediaProgress />
      </div>

      <div className="VideoTimeline__duration">{formatTimestamp(duration)}</div>
    </div>
  );
}
